import * as React from 'react';
import * as problems from "./style.module.scss";
export const Problems = () => {
  return (
    <section className={problems.problems}>
      <div className="container">
        <div className="row">
          <ol>
            <li className={problems.first}>
              <span>1</span>
              <p>Ребёнок не хочет учиться?</p>
            </li>
            <li className={problems.second}>
              <span>2</span>
              <p>Тратите целый вечер на запоминание информации, а утром ребёнок уже половину забыл?</p>
            </li>
            <li className={problems.third}>
              <span>3</span>
              <p>Хватит зубрить школьную программу всей семьей!<br/><b>Посмотрите наш вебинар!</b></p>
            </li>
          </ol>
          <ul>
            <li>
              <img src="https://fs.advance.ru/landing-pages/webinar/nauchite_detey_uchitsya/img1.png" alt={""}/>
            </li>
            <li className={problems.img2}>
              <img src="https://fs.advance.ru/landing-pages/webinar/nauchite_detey_uchitsya/img2.png" alt={""}/>
            </li>
            <li>
              <img src="https://fs.advance.ru/landing-pages/webinar/nauchite_detey_uchitsya/img3.png" alt={""}/>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};
